const LABELS_BY_TOKEN = {
  neutral: [
    "Checked Out",
    "Expired",
    "Voided",
    "Inactive",
    "Scheduled",
    "Unchecked",
    "Open",
    "Not Started",
    "Skipped",
    "Not Yet Imported",
    "Unmapped",
    "Off",
    "Loading",
  ],
  info: [
    "In Progress",
    "Launched",
    "Occupied",
    "Checked In",
    "Approved",
    "Boater Arrived",
  ],
  positive: [
    "Confirmed",
    "Accepted",
    "Completed",
    "Signed",
    "Completed In House",
    "Active",
    "Settled",
    "Refunded",
    "Succeeded",
    "Successful",
    "Returned",
    "Paid",
    "Published",
    "Closed",
    "Invoiced",
    "Success",
    "Successfully Imported",
    "Mapped",
    "On",
    "Vacant",
    "Ready For Return",
  ],
  warning: [
    "Pending",
    "Created",
    "Requested",
    "Unsent",
    "Undeliverable",
    "Sent",
    "In House Only",
    "Offer Pending",
    "Processing",
    "Queued",
    "Partially Refunded",
    "Refund Pending",
    "Incomplete",
    "Retrying",
    "On Hold",
    "Action Needed",
    "Verification In Progress",
    "Do Not Return",
    "Excluded",
    "Today",
    "Unknown Error",
  ],
  attention: [
    "Waitlisted",
    "Disputed",
    "Under Dispute",
    "Processing Refund",
    "Due Today",
    "Awaiting Approval",
  ],
  critical: [
    "Canceled",
    "Cancelled",
    "Payment Declined",
    "Declined",
    "Boater Declined",
    "Past Due",
    "Overdue",
    "Failed",
    "Unpaid",
    "Blocked",
    "Dispute Lost",
    "Reversed",
    "Incomplete Expired",
    "Unpublished",
  ],
  special: ["Work Complete"],
}

export const STATUS_TOKENS = Object.fromEntries(
  Object.entries(LABELS_BY_TOKEN).flatMap(([token, labels]) =>
    labels.map((label) => [label, token])
  )
)

const normalize = (status) =>
  String(status ?? "")
    .replace(/_/g, " ")
    .trim()
    .toLowerCase()

const TOKENS_BY_NORMALIZED_LABEL = Object.fromEntries(
  Object.entries(STATUS_TOKENS).map(([label, token]) => [
    normalize(label),
    token,
  ])
)

export const statusToken = (status) =>
  TOKENS_BY_NORMALIZED_LABEL[normalize(status)] ?? "neutral"
